import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	AfterViewInit,
	ChangeDetectorRef,
	HostListener,
	ViewChild,
	ElementRef
} from "@angular/core";
import { Router } from "@angular/router";
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators
} from "@angular/forms";
import { GlobalService } from "../../../services/global/global.service";
import { RegistrationRequest } from "../../../models/dmv/registration.request";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { RouteFrom } from "../../../models/routeFrom";
import { DMVDataService } from "../../../services/dmv/dmv-data.service";
import { AppUtil } from "../../../utils/app.util";
import { Observable } from "rxjs";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
//import * as jquery from 'jquery';
declare var $: any;
@Component({
	selector: "dmv-search",
	templateUrl: "./search.component.html",
	styleUrls: ["./search.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit, AfterViewInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		private formBuilder: FormBuilder,
		public megStoreService: MEGStoreService,
		public userStoreService: USERStoreService,
		public userDataService: USERDataService,
		private cd: ChangeDetectorRef
	) {}
	@ViewChild("searchSelectInput", { static: false })
	searchSelectInput: ElementRef;
	@ViewChild("pin", { static: false })
	pin: ElementRef;
	@ViewChild("licensePlate", { static: false })
	licensePlate: ElementRef;
	@ViewChild("dateOfBirth", { static: false })
	dateOfBirth: ElementRef;
	@ViewChild("expirationDate", { static: false })
	expirationDate: ElementRef;
	@ViewChild("infoWarningBox", { static: false })
	infoWarningBox: ElementRef;

	public mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
	public registeredType: boolean = false;
	public searchCriteria: string = "NO_SEARCH";
	public searchRegistrationForm: FormGroup;
	public submitted = false;
	public isloading: boolean = false;
	public agencyConfig: AgencyDmvConfigResponse;
	public errorMessage: string;
	public norecordFound: boolean = false;
	public qrCode: boolean = false;
	public hasRegistrationInProfile: boolean = false;
	public pinMaxlength: number = 15;
	public isPrivacy: boolean = false;
	public isPrivacyOpen: boolean = false;
	public showPrivacy: boolean = true;
	public isCallFromQRCode: boolean = false;
	ngAfterViewInit() {
		if (
			this.globalService.params &&
			this.globalService.params.token &&
			this.globalService.getDirectURLCall()
		) {
			this.searchRegistrations();
		} else if (window["qrDetail"] && this.globalService.getQrCall()) {
			this.globalService.setDirectURLCall(false);
			this.qrCode = true;
			const qrDetail = window["qrDetail"];
			setTimeout(() => {
				this.showPrivacy = false;
				if (
					(!qrDetail.pin && !qrDetail.licensePlate) ||
					(qrDetail.licensePlate &&
						(!qrDetail.expirationDate && !qrDetail.dateOfBirth))
				) {
					this.showPrivacy = true;
					this.setErrorMessage();
				} else {
					this.showPrivacy = true;
					if (qrDetail.licensePlate) {
						this.searchSelectInput.nativeElement.value = "1";

						this.updateSearchFields("1");
						this.searchRegistrationForm.controls.licensePlate.setValue(
							qrDetail.licensePlate
						);
						if (qrDetail.expirationDate) {
							this.registeredType = true;
							this.updateSearchFields("1");
							this.cd.detectChanges();
							this.searchRegistrationForm.controls.expirationDate.setValue(
								qrDetail.expirationDate
							);
						}
						if (qrDetail.dateOfBirth) {
							this.registeredType = false;
							this.updateSearchFields("1");
							this.cd.markForCheck();
							this.searchRegistrationForm.controls.dateOfBirth.setValue(
								qrDetail.dateOfBirth
							);
						}
					} else if (window["qrDetail"].pin) {
						this.searchSelectInput.nativeElement.value = "2";
						this.updateSearchFields("2");
						this.cd.detectChanges();
						this.searchRegistrationForm.controls.pin.setValue(
							window["qrDetail"].pin
						);
						if (
							qrDetail.dateOfBirth &&
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.pinSearchOption !== 4
						) {
							this.registeredType = false;
							this.searchRegistrationForm.controls.dateOfBirth.setValue(
								qrDetail.dateOfBirth
							);
						}
						if (
							qrDetail.expirationDate &&
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.pinSearchOption === 1
						) {
							this.registeredType = true;
							this.updateSearchFields("2");
							this.cd.detectChanges();
							this.searchRegistrationForm.controls.expirationDate.setValue(
								qrDetail.expirationDate
							);
						}
					}

					if (this.globalService.browserDetails.isDesktop) {
						$(".mdb-select").formSelect({
							destroy: true
						});
						$(".mdb-select").formSelect();
					}

					this.cd.markForCheck();
					this.searchRegistrations();
				}
			});
		} else {
			this.globalService.setDirectURLCall(false);
		}
	}
	@HostListener("document:touchend", ["$event"])
	closeDatepickerOnclick(event) {
		if (
			event.target.offsetParent !== null &&
			event.target.id !== "expirationDate"
		) {
			if (
				!(
					event.target.offsetParent.offsetParent &&
					event.target.offsetParent.offsetParent.classList.contains(
						"datepicker"
					)
				)
			) {
				if ($(".datepicker").is(":visible")) {
					$("#expirationDate").datepicker("hide");
				}
			}
		}
	}
	ngOnInit() {
		AppUtil.log("SearchComponent ngOnInit");
		this.searchRegistrationForm = this.formBuilder.group({});
		//if (!this.globalService.getQrCall()) {
		this.searchRegistrationForm.addControl(
			"privacy",
			new FormControl(this.dmvStoreService.isPrivacyCheck, Validators.required)
		);
		//	}
		this.dmvStoreService.agencyConfig$
			.subscribe(agencyConfig => {
				if (agencyConfig) {
					this.agencyConfig = agencyConfig;
				}
			})
			.unsubscribe();
		const userProfile = this.userStoreService.getUserProfile();
		if (
			userProfile &&
			userProfile.billingAccounts &&
			userProfile.billingAccounts.dmvAccounts &&
			userProfile.billingAccounts.dmvAccounts.length > 0
		) {
			userProfile.billingAccounts.dmvAccounts.forEach(item => {
				if (
					item.agencyID &&
					item.agencyID.toString() === this.dmvStoreService.selectedAgencyId
				) {
					this.hasRegistrationInProfile = true;
				}
			});
		}
		setTimeout(() => {
			if (this.globalService.browserDetails.isDesktop) {
				$(".mdb-select").formSelect();
			}
		});
	}

	public setErrorMessage() {
		this.errorMessage = this.megStoreService.configuration.megConfig.qrCodeErrorText;
		this.globalService.setQrCall(false);
		this.isloading = false;
		window.scrollTo(0, 0);
		this.cd.markForCheck();
	}
	public get f() {
		return this.searchRegistrationForm.controls;
	}
	public updateSearchFields(selectValue: string) {
		this.isPrivacy = true;
		let privacyValue = false;
		//this.registeredType = false;
		if (!this.globalService.getQrCall()) {
			//this.showPrivacy = false;
			privacyValue = this.searchRegistrationForm.controls.privacy.value;
			if (!privacyValue) {
				this.searchSelectInput.nativeElement.value = "NO_SEARCH";
				return;
			}
		}

		this.searchSelectInput.nativeElement.blur();
		AppUtil.log("SearchComponent updateSearchFields() ==>", selectValue);
		if (
			(selectValue === "9" || selectValue === "10") &&
			this.searchRegistrationForm.controls.privacy
		) {
			this.dmvStoreService.isPrivacyCheck = this.searchRegistrationForm.controls.privacy.value;
		}
		if (selectValue === "9") {
			this.router.navigate(["dmv-manual-renew"], { skipLocationChange: true });
			return;
		}
		if (selectValue === "10") {
			this.router.navigate(["dmv-duplicate"], { skipLocationChange: true });
			return;
		}
		let pin = "";
		let licensePlate = "";
		let dateOfBirth = "";
		let expirationDate = "";

		const qrDetail = window["qrDetail"];
		if (this.isCallFromQRCode) {
			if (
				this.searchRegistrationForm &&
				this.searchRegistrationForm.controls &&
				this.searchRegistrationForm.controls.pin
			) {
				this.searchRegistrationForm.controls.pin.setValue(qrDetail.pin);
			}
			if (
				this.searchRegistrationForm &&
				this.searchRegistrationForm.controls &&
				this.searchRegistrationForm.controls.licensePlate
			) {
				this.searchRegistrationForm.controls.licensePlate.setValue(
					qrDetail.licensePlate
				);
			}
			if (
				this.searchRegistrationForm &&
				this.searchRegistrationForm.controls &&
				this.searchRegistrationForm.controls.dateOfBirth
			) {
				this.searchRegistrationForm.controls.dateOfBirth.setValue(
					qrDetail.dateOfBirth
				);
			}

			if (
				this.searchRegistrationForm &&
				this.searchRegistrationForm.controls &&
				this.searchRegistrationForm.controls.expirationDate
			) {
				this.searchRegistrationForm.controls.expirationDate.setValue(
					qrDetail.expirationDate
				);
			}
		}

		if (
			this.searchRegistrationForm &&
			this.searchRegistrationForm.controls &&
			this.searchRegistrationForm.controls.pin &&
			this.searchRegistrationForm.controls.pin.value
		) {
			pin = this.isCallFromQRCode
				? qrDetail.pin
				: this.searchRegistrationForm.controls.pin.value;
		}
		if (
			this.searchRegistrationForm &&
			this.searchRegistrationForm.controls &&
			this.searchRegistrationForm.controls.licensePlate &&
			this.searchRegistrationForm.controls.licensePlate.value
		) {
			licensePlate = this.isCallFromQRCode
				? qrDetail.licensePlate
				: this.searchRegistrationForm.controls.licensePlate.value;
		}
		if (
			this.searchRegistrationForm &&
			this.searchRegistrationForm.controls &&
			this.searchRegistrationForm.controls.dateOfBirth &&
			this.searchRegistrationForm.controls.dateOfBirth.value
		) {
			dateOfBirth = this.isCallFromQRCode
				? qrDetail.dateOfBirth
				: this.searchRegistrationForm.controls.dateOfBirth.value;
		}

		if (
			this.searchRegistrationForm &&
			this.searchRegistrationForm.controls &&
			this.searchRegistrationForm.controls.expirationDate &&
			this.searchRegistrationForm.controls.expirationDate.value
		) {
			expirationDate = this.isCallFromQRCode
				? qrDetail.expirationDate
				: this.searchRegistrationForm.controls.expirationDate.value;
		}
		this.searchCriteria = selectValue;
		this.cd.markForCheck();
		//this.searchRegistrationForm = this.formBuilder.group({})
		if (selectValue === "2") {
			if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig.pinSearchOption === 4
			) {
				this.registeredType = false;
				let val = Validators.pattern("");
				if (this.qrCode) {
					this.pinMaxlength = 150;
					val = Validators.pattern(/^[0-9,]+$/);
				} else {
					val = Validators.pattern(/^[0-9]*$/);
				}
				this.searchRegistrationForm = this.formBuilder.group({
					pin: [pin, [Validators.required, val]]
				});
			} else {
				if (!this.registeredType) {
					this.searchRegistrationForm = this.formBuilder.group({
						dateOfBirth: [
							dateOfBirth,
							Validators.compose([
								Validators.required,
								Validators.pattern(
									/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
								),
								this.globalService.dateRangeValidator("max")
							])
						],
						pin: [pin, [Validators.required, Validators.pattern(/^[0-9]*$/)]]
					});
				} else {
					this.searchRegistrationForm = this.formBuilder.group({
						expirationDate: [
							expirationDate,
							Validators.compose([
								Validators.required,
								Validators.pattern(
									/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
								),
								this.globalService.dateRangeValidator("min")
							])
						],
						pin: [pin, [Validators.required, Validators.pattern(/^[0-9]*$/)]]
					});
				}
			}
			setTimeout(() => {
				this.pin.nativeElement.focus();
			});
		} else if (selectValue === "1") {
			if (this.registeredType) {
				this.searchRegistrationForm = this.formBuilder.group({
					expirationDate: [
						expirationDate,
						Validators.compose([
							Validators.required,
							Validators.pattern(
								/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
							),
							this.globalService.dateRangeValidator("min")
						])
					],
					licensePlate: [
						licensePlate,
						[Validators.required, Validators.pattern(/^[a-zA-Z\d\-\s]+$/)]
					]
				});
				setTimeout(() => {
					this.licensePlate.nativeElement.focus();
				});
			} else {
				this.searchRegistrationForm = this.formBuilder.group({
					dateOfBirth: [
						dateOfBirth,
						Validators.compose([
							Validators.required,
							Validators.pattern(
								/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
							),
							this.globalService.dateRangeValidator("max")
						])
					],
					licensePlate: [
						licensePlate,
						[Validators.required, Validators.pattern(/^[a-zA-Z\d\-\s]+$/)]
					]
				});
				setTimeout(() => {
					this.licensePlate.nativeElement.focus();
				});
			}
			setTimeout(() => {
				const elmentRef: any =
					this.infoWarningBox && this.infoWarningBox.nativeElement
						? this.infoWarningBox.nativeElement.querySelector("a")
						: null;
				if (elmentRef) {
					elmentRef.addEventListener("click", e => {
						this.searchSelectInput.nativeElement.value = "2";
						this.updateSearchFields("2");
						if (this.globalService.browserDetails.isDesktop) {
							$(".mdb-select").formSelect();
						}
						this.cd.detectChanges();
					});
				}
			});
		}
		this.searchRegistrationForm.addControl(
			"privacy",
			new FormControl(privacyValue)
		);
		if (!this.globalService.getQrCall()) {
			this.searchRegistrationForm.controls.privacy.setValidators([
				Validators.required
			]);
		}
		this.isCallFromQRCode = false;
		const that = this;
		setTimeout(() => {
			$("#expirationDate")
				.datepicker({
					direction: "down",
					format: "mm/dd/yyyy"
				})
				.on("hide", function(e) {
					if (e.date) {
						const date = e.date.getDate();
						const month = e.date.getMonth() + 1;
						const year = e.date.getFullYear();

						const fullDate =
							(month < 10 ? "0" + month : month) +
							"/" +
							(date < 10 ? "0" + date : date) +
							"/" +
							year;
						that.searchRegistrationForm.controls.expirationDate.setValue(
							fullDate
						);
					}
				});
		});
	}

	public goBack() {
		AppUtil.log("SearchComponent goBack() ==>");
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "add-another"
		) {
			if (!this.dmvStoreService.registrationsInCart.dmvRegistrations) {
				this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
			} else {
				if (
					this.dmvStoreService.registrationsInCart.dmvRegistrations &&
					this.dmvStoreService.routeFrom &&
					this.dmvStoreService.routeFrom.orderNumber ===
						this.dmvStoreService.registrationsInCart.dmvRegistrations.length
				) {
					this.router.navigate(["dmv-review-cart"], {
						skipLocationChange: true
					});
				} else {
					this.router.navigate(["dmv-search-results"], {
						skipLocationChange: true
					});
				}
			}
		} else {
			if (this.globalService.params) {
				this.globalService.setDirectURLCall(false);
				this.globalService.params.agencyID = null;
				this.globalService.params.productTypeID = null;
			}
			this.router.navigate(["county-landing"], { skipLocationChange: true });
		}
	}

	public updateregisteredType() {
		this.registeredType = false;
	}
	public changeRegisteredType(event) {
		AppUtil.log("SearchComponent changeRegisteredType() ==>");
		this.registeredType = event.target.checked;
		this.updateSearchFields(this.searchCriteria);
	}
	public findRegistrations(registrationRequest) {
		AppUtil.log(
			"SearchComponent findRegistrations() ==> registrationRequest:",
			registrationRequest
		);
		this.dmvDataService
			.getRegistrationResponse(
				registrationRequest.agencyID,
				registrationRequest.pin,
				registrationRequest.dateOfBirth,
				registrationRequest.licensePlate,
				registrationRequest.expirationDate,
				registrationRequest.pageSize,
				registrationRequest.targetPageNumber,
				this.dmvStoreService.sessionID,
				this.qrCode,
				registrationRequest.token
			)
			.subscribe(
				response => {
					AppUtil.log(
						"SearchComponent findRegistrations() ==> response:",
						response
					);
					if (response) {
						this.dmvStoreService.registrations = response;
						if (response.registrations && response.registrations.length > 0) {
							this.router.navigate(["dmv-search-results"], {
								skipLocationChange: true
							});
						} else {
							// if (window["qrDetail"] && this.globalService.getQrCall()) {
							// 	this.errorMessage = this.megStoreService.configuration.megConfig.qrCodeErrorText;
							// } else {
							this.norecordFound = true;
							// }
							this.updateSearchFieldsByQRCode();
							//this.globalService.setQrCall(false);
							this.globalService.params = null;
							window["externallink"] = {};
							this.globalService.setDirectURLCall(false);
							this.isloading = false;
							this.isPrivacy = false;
							window.scrollTo(0, 0);
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log("SearchComponent findRegistrations() ==> error:", error);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;

						this.isloading = false;
						this.globalService.setQrCall(false);
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}
	public updateSearchFieldsByQRCode() {
		if (this.globalService.getQrCall()) {
			this.privacyClicked();

			this.isCallFromQRCode = true;
			this.globalService.setQrCall(false);
		}
	}
	public findProfileRegistrations() {
		AppUtil.log(
			"SearchComponent findProfileRegistrations() ==> registrationRequest:"
		);
		this.userDataService
			.getRegistraions(
				this.dmvStoreService.selectedAgencyId,
				this.dmvStoreService.sessionID,
				this.userStoreService.getUserProfile().megUserGUID,
				this.agencyConfig.agencyDmvConfig.pageSize
			)
			.subscribe(
				response => {
					AppUtil.log(
						"SearchComponent findRegistrations() ==> response:",
						response
					);
					if (response) {
						this.dmvStoreService.registrations = response;
						if (response.registrations && response.registrations.length > 0) {
							this.router.navigate(["dmv-search-results"], {
								skipLocationChange: true
							});
						} else {
							this.norecordFound = true;
							this.globalService.setQrCall(false);
							this.globalService.setDirectURLCall(false);
							this.isloading = false;
							window.scrollTo(0, 0);
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log("SearchComponent findRegistrations() ==> error:", error);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;

						this.isloading = false;
						this.globalService.setQrCall(false);
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}
	public openPrivacy() {
		this.isPrivacyOpen = true;
	}
	public closePrivacy() {
		this.isPrivacyOpen = false;
	}

	public privacyClicked() {
		setTimeout(() => {
			this.searchCriteria = "NO_SEARCH";
			this.searchSelectInput.nativeElement.value = "NO_SEARCH";
			$(".mdb-select").formSelect({
				destroy: true
			});
			$(".mdb-select").formSelect();
			this.cd.markForCheck();
		});
	}
	public searchRegistrations() {
		if (
			!this.globalService.getQrCall() &&
			!window["externallink"] &&
			!this.globalService.getDirectURLCall()
		) {
			this.searchRegistrationForm.controls.privacy.setValidators([
				Validators.required
			]);
		}

		if (
			window["externallink"] &&
			window["externallink"].token &&
			this.globalService.getDirectURLCall()
		) {
			this.isloading = true;
			this.errorMessage = null;
			const registrationRequest: RegistrationRequest = new RegistrationRequest();
			registrationRequest.agencyID = window["externallink"].agencyID;
			registrationRequest.token = window["externallink"].token;
			registrationRequest.pageSize = this.agencyConfig.agencyDmvConfig.pageSize;
			this.findRegistrations(registrationRequest);
		} else if (this.searchCriteria === "SEARCH_BY_PROFILE") {
			AppUtil.log("SearchComponent SEARCH_BY_PROFILE ==>");
			this.norecordFound = false;

			this.isloading = true;
			this.errorMessage = null;
			this.findProfileRegistrations();
		} else {
			AppUtil.log("SearchComponent searchRegistrations() ==>");
			this.norecordFound = false;
			console.log("searchRegistrations:");
			console.log(
				"HomeComponent selectCounty: this.globaService.isHeaderDisplayed$ = " +
					this.globalService.getHeaderDisplayedValue()
			);
			this.submitted = true;
			if (this.searchRegistrationForm.invalid) {
				console.log("searchRegistrationForm.invalid");

				this.cd.markForCheck();

				setTimeout(() => {
					this.globalService.setQrCall(false);
					this.cd.markForCheck();
				});

				//	this.isloading = false;
				return;
			}
			const registrationRequest: RegistrationRequest = new RegistrationRequest();
			registrationRequest.agencyID = this.agencyConfig.agencyDmvConfig.agencyID;
			if (
				this.searchRegistrationForm.controls["dateOfBirth"] &&
				this.searchRegistrationForm.controls["dateOfBirth"].value
			) {
				registrationRequest.dateOfBirth = this.searchRegistrationForm.controls[
					"dateOfBirth"
				]
					? this.searchRegistrationForm.controls["dateOfBirth"].value
					: "";
			}

			registrationRequest.licensePlate = this.searchRegistrationForm.controls[
				"licensePlate"
			]
				? this.searchRegistrationForm.controls["licensePlate"].value.trim()
				: "";

			registrationRequest.pin = this.searchRegistrationForm.controls["pin"]
				? this.searchRegistrationForm.controls["pin"].value.trim()
				: "";
			registrationRequest.expirationDate = this.searchRegistrationForm.controls[
				"expirationDate"
			]
				? this.searchRegistrationForm.controls["expirationDate"].value
				: "";

			registrationRequest.pageSize = this.agencyConfig.agencyDmvConfig.pageSize;

			this.dmvStoreService.registrationSearchRequest = registrationRequest;
			this.dmvStoreService.targetPageNumber = 1;
			if (this.searchRegistrationForm.controls.privacy) {
				this.dmvStoreService.isPrivacyCheck = this.searchRegistrationForm.controls.privacy.value;
			}
			this.isloading = true;
			this.errorMessage = null;
			this.findRegistrations(registrationRequest);

			this.cd.markForCheck();
		}
	}
}
